import { jsx as _jsx } from "react/jsx-runtime";
import { Button as ButtonPrimitive } from "@base-ui/react/button";
import { cva } from "class-variance-authority";
import { cn } from "../lib/cn.js";
export const buttonVariants = cva("group/button inline-flex min-h-11 shrink-0 cursor-pointer items-center justify-center rounded-lg border border-transparent bg-clip-padding text-sm font-semibold whitespace-nowrap transition-all outline-none select-none focus-visible:border-ring focus-visible:ring-3 focus-visible:ring-ring/50 active:not-aria-[haspopup]:translate-y-px disabled:pointer-events-none disabled:cursor-default disabled:opacity-50 aria-disabled:cursor-default aria-invalid:border-destructive aria-invalid:ring-3 aria-invalid:ring-destructive/20 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4", {
    variants: {
        variant: {
            default: "bg-primary text-primary-foreground shadow-[var(--oc-shadow-button)] hover:bg-primary-hover",
            primary: "bg-primary text-primary-foreground shadow-[var(--oc-shadow-button)] hover:bg-primary-hover",
            outline: "border-input bg-background text-foreground hover:bg-muted hover:text-foreground aria-expanded:bg-muted aria-expanded:text-foreground dark:bg-input/30 dark:hover:bg-input/50",
            secondary: "bg-secondary text-secondary-foreground hover:bg-[color-mix(in_oklch,var(--secondary),var(--foreground)_5%)] aria-expanded:bg-secondary aria-expanded:text-secondary-foreground",
            ghost: "hover:bg-muted hover:text-foreground aria-expanded:bg-muted aria-expanded:text-foreground dark:hover:bg-muted/50",
            destructive: "bg-destructive-soft text-destructive hover:bg-destructive-soft hover:border-destructive/50 focus-visible:border-destructive/40 focus-visible:ring-destructive/20 dark:focus-visible:ring-destructive/40",
            link: "text-primary underline-offset-4 hover:underline",
        },
        size: {
            default: "gap-1.5 px-4 has-data-[icon=inline-end]:pr-3 has-data-[icon=inline-start]:pl-3",
            compact: "gap-1 px-3 text-[0.8125rem]",
            large: "min-h-12 gap-2 px-5 text-base",
            xs: "gap-1 px-2 text-xs [&_svg:not([class*='size-'])]:size-3",
            sm: "gap-1 px-2.5 text-[0.8rem] [&_svg:not([class*='size-'])]:size-3.5",
            lg: "gap-1.5 px-4",
            icon: "size-11 p-0",
            "icon-xs": "size-11 rounded-[min(var(--radius-md),10px)] p-0 [&_svg:not([class*='size-'])]:size-3",
            "icon-sm": "size-11 rounded-[min(var(--radius-md),12px)] p-0",
            "icon-lg": "size-12 p-0",
        },
    },
    defaultVariants: {
        variant: "default",
        size: "default",
    },
});
function Button({ className, variant = "default", size = "default", ...props }) {
    return (_jsx(ButtonPrimitive, { "data-slot": "button", className: cn(buttonVariants({ variant, size, className })), ...props }));
}
export { Button };
//# sourceMappingURL=button.js.map